import { Component, OnInit } from '@angular/core';
import { UserOutputDto, UserService } from 'src/generated_client';

@Component({
  selector: 'app-app-users',
  templateUrl: './app-users.component.html',
  styleUrls: ['./app-users.component.css']
})
export class AppUsersComponent implements OnInit {

  displayedColumns: string[] = ['user', 'email', 'phone', 'registerDate', 'totalOrders'];
  allUsers: UserOutputDto[] = [];

  constructor(
    public userService: UserService
  ) {
  }

  ngOnInit() {
    this.userService.apiUserGetAllGet().subscribe(users => {
      this.allUsers = users;
    });
  }
}